import { getWindowObject } from '@eventbrite/feature-detection';

const getTextWidth = (text = '', ctx: CanvasRenderingContext2D) =>
    ctx.measureText(text).width;

const getElementTextStyles = (element: HTMLElement) => {
    const computedStyle = getWindowObject('getComputedStyle')?.(element);

    if (!computedStyle) {
        return '';
    }

    const fontSize = computedStyle.getPropertyValue('font-size');
    const fontFamily = computedStyle.getPropertyValue('font-family');
    return `${fontSize} ${fontFamily}`; // '20px Arial'
};

const mapWordsToWidth = (words: Array<string>, element: HTMLElement) => {
    const canvas = document.createElement('canvas') as HTMLCanvasElement;
    const ctx = canvas.getContext('2d');

    if (!ctx) {
        return [];
    }

    ctx.font = getElementTextStyles(element);

    return words.map((word) => getTextWidth(word, ctx)) as Array<number>;
};

const interleave = <Item, NewElement>(
    array: Array<Item>,
    newElement: NewElement,
) => array.flatMap((element) => [element, newElement]).slice(0, -1);

export const getNumberOfTextLines = (text = '', element: HTMLElement) => {
    if (!text) {
        return 0;
    }

    const elementWidth = element?.getBoundingClientRect().width;
    const wordsWidths = mapWordsToWidth(
        // Splitting by blanks and then inserting the blanks as independent
        // elements in the text to take its width into account
        interleave(text.split(' '), ' '),
        element,
    );

    const widthForLine = wordsWidths.reduce<Array<number>>(
        (lines, wordWidth) => {
            const newWordsInLineWidth: number =
                lines[lines.length - 1] + wordWidth;

            return newWordsInLineWidth > elementWidth
                ? [...lines, wordWidth]
                : [...lines.slice(0, -1), newWordsInLineWidth];
        },
        [0],
    );

    return widthForLine.length;
};
